import { useEffect } from 'react';

const userVoiceProperties = {
  href: 'javascript:void(0)',
  'data-uv-lightbox': 'classic_widget',
  'data-uv-mode': 'feedback',
  'data-uv-primary-color': '#2c2ca8',
  'data-uv-link-color': '#3fc59f',
  'data-uv-forum-id': '271343',
};

const useIntercomUserVoice = () => {
  useEffect(() => {
    // UserVoice
    const uv = document.createElement('script');
    uv.type = 'text/javascript';
    uv.async = true;
    uv.src =
      'https://hostfully.uservoice.com/widget_environment/gyzodBYiFk7jcbHcPKLf7A.js';
    document.body.appendChild(uv);

    return () => {
      document.body.removeChild(uv);
    };
  }, []);

  return { userVoiceProperties };
};

export default useIntercomUserVoice;
